import React, { Component } from 'react'
import { isEqual } from 'lodash'

import cn from 'classnames'
import s from './Page.scss'
import sLay from 'styles/modules/layout.scss'

import { Container } from 'components/Layout'
import { Helmet } from 'react-helmet'
import ScrollToTop from 'components/Scroll/ScrollToTop'

const scrollContainerId = 'scrollContainer'

export default class Page extends Component {
  scrollContainerEl = undefined
  componentWillUnmount() {
    if (this.scrollContainerEl) {
      this.scrollContainerEl.removeEventListener('scroll', this.handleScroll)
    }
  }
  handleScroll = () => {
    const { setAtTop } = this.props
    setAtTop(this.scrollContainerEl.scrollTop === 0)
  }
  componentDidMount() {
    // Set the layout
    const { setLayout, layout } = this.props
    setLayout(layout)
    // Add the container listeners
    this.scrollContainerEl = document.getElementById(scrollContainerId)
    this.scrollContainerEl.addEventListener('scroll', this.handleScroll)
    setTimeout(this.handleScroll, 1)
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.layout, nextProps.layout)) {
      this.props.setLayout(nextProps.layout)
    }
  }
  render() {
    const {
      contained,
      layout,
      absChildren,
      title,
      description,
      image,
      setLayout,
      setAtTop,
      children,
      style,
      className,
      ...otherProps
    } = this.props
    const getInner = () => (contained ? <Container>{children}</Container> : children)

    return (
      <div className={cn(sLay['layout-column'], sLay.flex)}>
        <div
          id="scrollContainer"
          className={cn(
            sLay.flex,
            s.page,
            { [s.app]: layout && layout.header && layout.header !== 'landing' },
            className
          )}
          style={style}
          {...otherProps}
        >
          <Helmet>
            <title>{title}</title>
            <meta property="og:title" content={title} />
            <meta name="description" content={description || 'Calls and Internet. Made Simple.'} />
            <meta
              property="og:description"
              content={description || 'Calls and Internet. Made Simple.'}
            />
            <meta property="og:image" content={image} />
          </Helmet>
          <ScrollToTop />
          {getInner()}
        </div>
        {absChildren}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Page/Page.jsx